<template>
  <div class="userinfo">
    <div class="info-warp">
      <div class="info">
        <div>头像</div>
        <div class="image">
          <img :src="userInfo.headimg" v-if="userInfo.headimg" />
        </div>
      </div>
      <div class="info">
        <div>名称</div>
        <div>{{ userInfo.userName }}</div>
      </div>
      <div class="info">
        <div>电话号码</div>
        <div>{{ userInfo.tel }}</div>
      </div>
    </div>
    <div class="btn">
      <div class="changebtn"><button @click="goto">修改密码</button></div>
      <div class="quit"><button @click="quit">退出登录</button></div>
    </div>
  </div>
</template>
<script>
import { removeToken } from '@/utils/Token'
export default {
  name: 'userInfo',
  data () {
    return {
      userInfo: ''
    }
  },
  methods: {
    async getUserInfo () {
      const result = await this.$store.dispatch('user/getUserInfo')
      this.userInfo = result
    },
    quit () {
      removeToken()
    },
    goto () {
      this.$router.push({
        path: '/resetpassword'
      })
    }
  },
  created () {
    this.getUserInfo()
  }
}
</script>
<style lang="scss" scoped>
.userinfo {
  // @include flexBox(space-between);
  font-size: 0.28rem;
  .info-warp {
    width: 6.58rem;
    padding: 0.3rem;
    margin: auto;
    background: white;
    margin-top: 0.5rem;
    border-radius: 10px;
    .info {
      margin: 0.2rem 0;
      @include flexBox(space-between);
      .image {
        width: 1.56rem;
        height: 1.56rem;
        border-radius: 50%;
      }
      img {
        width: 1.56rem;
        height: 1.56rem;
        border-radius: 50%;
      }
    }
  }
  .btn {
    margin-top: 6rem;
    .changebtn {
      button {
        @include btn(#ff6161, 0.72rem);
        width: 7.18rem;
      }
    }
    .quit {
      margin-top: 0.3rem;
      button {
        @include btn(#ffffff, 0.72rem);
        color: #666666;
        border: 1px solid #666666;
        width: 7.18rem;
      }
    }
  }
}
</style>